export const JUNO_ERROR_CONTROLLERS_MAX_NUMBER = 'juno.error.controllers.max_number';
export const JUNO_ERROR_CONTROLLERS_ANONYMOUS_NOT_ALLOWED =
  'juno.error.controllers.anonymous_not_allowed';
export const JUNO_ERROR_CONTROLLERS_REVOKED_NOT_ALLOWED =
  'juno.error.controllers.revoked_not_allowed';
export const JUNO_ERROR_CONTROLLERS_ADMIN_NO_EXPIRY = 'juno.error.controllers.admin_no_expire';
export const JUNO_ERROR_CONTROLLERS_EXPIRY_IN_PAST = 'juno.error.controllers.expiry_in_past';

export const JUNO_ERROR_MEMORY_STABLE_EXCEEDED = 'juno.error.memory.stable_exceeded';
export const JUNO_ERROR_MEMORY_HEAP_EXCEEDED = 'juno.error.memory.heap_exceeded';

export const JUNO_ERROR_CYCLES_DEPOSIT_BALANCE_LOW = 'juno.error.cycles.deposit_balance_low';
export const JUNO_ERROR_CYCLES_DEPOSIT_FAILED = 'juno.error.cycles.deposit_failed';

export const JUNO_ERROR_CANISTER_CREATE_FAILED = 'juno.error.canister.create_failed';
export const JUNO_ERROR_CANISTER_INSTALL_CODE_FAILED = 'juno.error.canister.install_code_failed';

export const JUNO_ERROR_SEGMENT_STOP_FAILED = 'juno.error.segment.stop_failed';
export const JUNO_ERROR_SEGMENT_DELETE_FAILED = 'juno.error.segment.delete_failed';

export const JUNO_ERROR_CMC_CALL_LEDGER_FAILED = 'juno.error.cmc.call_ledger_failed';
export const JUNO_ERROR_CMC_LEDGER_TRANSFER_FAILED = 'juno.error.cmc.ledger_transfer_failed';
export const JUNO_ERROR_CMC_CALL_CREATE_CANISTER_FAILED =
  'juno.error.cmc.call_create_canister_failed';
export const JUNO_ERROR_CMC_CREATE_CANISTER_FAILED = 'juno.error.cmc.create_canister_failed';
export const JUNO_ERROR_CMC_INSTALL_CODE_FAILED = 'juno.error.cmc.install_code_failed';

export const JUNO_ERROR_INVALID_REGEX = 'juno.error.invalid_regex';
